import React from 'react'

function SuccessMessage(props) {
    return (

        <div className="px-4">
            <div className="flex justify-between p-4 rounded-md bg-green-50 border border-green-300">
                <div className="flex gap-3 sm:items-center">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 rounded-full text-green-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <p className="text-green-600 sm:text-sm">
                       {props.message}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SuccessMessage